<template>
  <ul class="h8">
    <slot></slot>
    <li v-for="item in links" v-if="item.link && item.label">
      <template v-if="item.link.type === 'Link.document'">
        <router-link :to="internalRt(item.link.type, item.link.value.document.uid)">{{item.label.value[0].text}}</router-link>
      </template>
      <template v-else-if="item.link.type === 'Link.web'">
        <a :href="item.link.value.url" :target="item.link.value.target" rel="noopener">{{item.label.value[0].text}}</a>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'FooterLink',
  props: ['links'],
  data () {
    return {

    }
  },
  methods: {
    internalRt (type, slug) {
      if (!slug || !type) return
      const name = type === 'collection' ? 'Collection' : 'Page'
      return {
        name: name,
        params: {
          slug: slug
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';
$gap: $gutter; // (23/12)*1em;
$margin: $gutter*1.333;
ul{
  padding:$margin/2 0;
}
li{
  display: inline-block;
  margin:$margin/2 $gap/2;
}
@include on_mobile () {
  ul {
    padding-left:$gap;
    padding-right:$gap;
  }
}
</style>



// WEBPACK FOOTER //
// FooterLinks.vue?7a5f50d4